<template>
	<div class="">
		<div v-if="isLoading" class="col-12">
			<!-- begin loader -->
			<beat-loader-component v-if="isLoading" :isLoading="isLoading"></beat-loader-component>
			<!-- end loader -->
		</div>
		<div v-else class="row">
			<div class="col-md-12 pb-3">
				<div class="row">

					<div class="mb-2 p-2 card col-8">
						<div class="d-flex mt-4 justify-content-center align-items-center justify-content-lg-start gap-3">
							<div class="col text-center" v-if="
								String(
									form.customer_type
								).toUpperCase() ==
								'INDIVIDUAL'
							">
								<img v-if="imageLoaded" v-bind:src="frontImgUrl" alt="Ghana Card Front" @load="handleImageLoad" style="height: 180px" class="img-fluid text-center gallery-image" />
								<img v-else src="@/assets/img/Ghana-Card-Front.png" alt="Ghana Card Front" style="height: 180px" class="img-fluid text-center gallery-image" />
								<p class="mt-2 akkurate-green fw-bold">
									GH Card - Front
								</p>
							</div>
							<div class="col text-center" v-if="
								String(
									form.customer_type
								).toUpperCase() ==
								'INDIVIDUAL'
							">
								<img v-if="imageLoaded" v-bind:src="backImgUrl" alt="Ghana Card Back" @load="handleImageLoad" style="height: 180px" class="img-fluid text-center gallery-image" />
								<img v-else src="@/assets/img/Ghana-Card-Front.png" alt="Ghana Card Back" style="height: 180px" class="img-fluid text-center gallery-image" />
								<p class="mt-2 akkurate-green fw-bold">
									GH Card - Back
								</p>
							</div>

							<div class="col text-center" v-if="String(form.customer_type).toUpperCase() == 'INDIVIDUAL'">
								<img v-bind:src="form.signature_image_path" alt="Signature" style="height:180px" class="img-fluid text-center gallery-image" />
								<p class="mt-2 akkurate-green fw-bold">Signature</p>
							</div>
						</div>
					</div>

					<div class="row col-4 mb-2">
						<div class="col-12 d-flex flex-column flex-sm-row align-items-center align-items-sm-start justify-content-center justify-content-sm-start my-1 pb-1 border-bottom border-gray-200">
							<!-- Profile Picture -->
							<img id="profile-picture" :src="form.passport_pic_path" alt="Member Profile" class="w-auto h-auto rounded-circle object-fit-cover mb-3 mb-sm-0 me-sm-4" style="width: 130px !important; height: 130px !important;">

							<!-- Member Core Details -->
							<div class="text-center text-dark text-sm-start">
								<h1 class="fs-2 fw-bold text-dark mb-1 font-lg " id="member-full-name">{{ getFullName }}
								</h1>
								<p class="text-secondary akkurate-small mb-1 ">Member Code: <span class="fw-medium" id="member-id">{{ form.code }}</span></p>
								<p class="text-secondary akkurate-small mb-2 font-primary">USSD Status: <span class="fw-medium" id="member-status-badge" :class="statusBadge(form.ussd_status || 'INACTIVE')">{{ form.ussd_status ||
									"INACTIVE" }}</span></p>
								<div class="d-flex align-items-center justify-content-center justify-content-sm-start gap-2">
									<span id="member-status-badge" :class="statusBadge(form.status)">{{ form.status
									}}</span>
									<div class="dropdown custom-pointer text-end">
										<div title="Status" id="dropdownMenu" class="form-select form-select-sm shadow-sm focus:border-green-500 focus:ring focus:ring-green-200 focus:ring-opacity-50" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
											<span class="ms-2 px-3 fw-bold">
												{{ form.status }}
											</span>
										</div>
										<div class="dropdown-menu dropdown-menu-end shadow animated--fade-in" aria-labelledby="dropdownMenu">
											<div class="dropdown-header py-2">Status</div>
											<b-button v-if="form.status != 'Active'" class="dropdown-item" @click="setUserStatus('Active', form)">
												<span class="small">Active</span>
											</b-button>
											<b-button v-if="form.status != 'Inactive'" class="dropdown-item" @click="setUserStatus('Inactive', form)">
												<span class="small">Inactive</span>
											</b-button>
											<b-button v-if="form.status != 'Dormant'" class="dropdown-item" @click="setUserStatus('Dormant', form)">
												<span class="small">Dormant</span>
											</b-button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row col-12 text-dark mt-auto">
							<p class="fw-bolder p-0 ps-4 m-0 mt-2 col-4">
								{{ form.gender?.toUpperCase() }}
							</p>
							<p class="fw-bolder p-0 m-0 ps-1 col-8 mt-auto">
								{{ getBranch }}
							</p>
							<p class="fw-bolder p-0 m-0 ps-4 col-4 font-bold">ADDRESS:</p>
							<p class="text-wrap p-0 m-0 ps-1 col-8">
								{{ form.address }}
							</p>

							<p class="p-0 m-0 ps-4 col-4 font-bold">TEL:</p>
							<p class="col-8 p-0 ps-1 m-0">
								{{ form.mobile }}
							</p>

							<p class="p-0 m-0 ps-4 col-4 font-bold">EMAIL:</p>
							<p class="col-8 p-0 m-0 ps-1">
								{{ form.email }}
							</p>

							<p class="p-0 m-0 ps-4 col-4 font-bold">REG DATE:</p>
							<p class="col-8 p-0 m-0 ps-1">
								{{ new Date(form.registered_date).toDateString() }}
							</p>
							<p class="p-0 m-0 ps-4 col-4 font-bold">STAFF ID:</p>
							<p class="col-8 p-0 m-0 ps-1">
								{{ form.staff_id }}
							</p>
						</div>
					</div>

				</div>

				<!-- <div class="row justify-content-between py-1 px-4 mb-2 align-items-center akkurate-small akkurate-green" style="background-color: #03867333;">
					<p class="col-6 ms-1 m-0 text-nowrap" style="width: fit-content;">RO: <span class="ms-2 fw-bold">{{
						getRoInfo }}</span></p>


					<div class="col-4 d-flex flex-row justify-content-between align-items-center">
						<p class="m-0 text-nowrap" style="width: fit-content;">
							USSD Status:
							<span class="ms-2 px-3 fw-bold" :class="statusBadge(form.accounts)">{{
								form.accounts[0]?.status
							}}</span>
						</p>

						<div class="dropdown custom-pointer text-end">
							<div title="Status" id="dropdownMenu" class="custom-pointer text-white dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<span class="ms-2 px-3 fw-bold" :class="activeStatusBadge(form.status)">
									{{ form.status }}
								</span>
							</div>
							<div class="dropdown-menu dropdown-menu-end shadow animated--fade-in" aria-labelledby="dropdownMenu">
								<div class="dropdown-header py-2">Status</div>
								<b-button v-if="form.status != 'Active'" class="dropdown-item" @click="setUserStatus('Active', form)">
									<span class="small">Active</span>
								</b-button>
								<b-button v-if="form.status != 'Inactive'" class="dropdown-item" @click="setUserStatus('Inactive', form)">
									<span class="small">Inactive</span>
								</b-button>
								<b-button v-if="form.status != 'Dormant'" class="dropdown-item" @click="setUserStatus('Dormant', form)">
									<span class="small">Dormant</span>
								</b-button>
							</div>
						</div>
					</div>
				</div> -->

				<b-tabs justified>
					<b-tab active class="text-xs">
						<template #title>
							<font-awesome-icon :icon="['fas', 'user']" /><br><!-- Font Awesome icon -->
							{{ customerTypeTitle() }}
						</template>
						<div class="card card-shape home-box">
							<div class="card-body">
								<div class="col-md-12">
									<b-card-group deck>
										<b-card>
											<b-card-body>
												<div class="row" v-if="String(form.customer_type).toUpperCase() == 'INDIVIDUAL'">
													<div class="col-12 col-md-1">
														<label class="akkurate-dark" for="title">Title</label>
														<b-form-group id="title" label-for="title">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.title" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-3">
														<label class="akkurate-dark" for="search_term">First
															Name</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.first_name" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="search_term">Middle
															Name</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.middlename" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="search_term">Surname</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.last_name" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="search_term">Branch</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.branch?.name" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="search_term">Gender</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.gender" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="search_term">Cust.
															Code</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.code" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="search_term">Ext. Cust.
															Code</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.external_code" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="dob">Date of Birth</label>
														<b-form-group id="dob" label-for="dob">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.date_of_birth" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="marital_status">Marital
															Status</label>
														<b-form-group id="marital_status" label-for="marital_status">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.marital_status" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="email">Email</label>
														<b-form-group id="email" label-for="email">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.email" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="mobile">Mobile</label>
														<b-form-group id="mobile" label-for="mobile">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.mobile" disabled></b-form-input>
														</b-form-group>
													</div>

													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="ghana_card">Ghana Card
															Number</label>
														<b-form-group id="ghana_card" label-for="ghana_card">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.ghana_card_number" disabled></b-form-input>
														</b-form-group>
													</div>

													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="ghana_card">Status</label>
														<b-form-group id="status" label-for="status">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.status" disabled></b-form-input>
														</b-form-group>
													</div>

													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="ghana_card">Source</label>
														<b-form-group id="source" label-for="source">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.source" disabled></b-form-input>
														</b-form-group>
													</div>

													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="ghana_card">Pin Set</label>
														<b-form-group id="status" label-for="status">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.is_pin_changed ==
																1
																? 'Yes'
																: 'No'
																" disabled></b-form-input>
														</b-form-group>
													</div>

													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="registered_date">Registered
															Date</label>
														<b-form-group id="status" label-for="status">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.registered_date
																" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="approved_by">Approved
															By</label>
														<b-form-group id="approved_by" label-for="approved_by">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.approved_by
																" disabled></b-form-input>
														</b-form-group>
													</div>

													<!-- <div class="col-12 col-md-1 pe-0">
												<label class="akkurate-dark" for="approved_by">USSD Status</label>
												<b-form-group id="approved_by" label-for="approved_by" class="mt-2">
													<span class="akkurate-small" :class="statusBadge(form.accounts)">{{ form.accounts[0]?.status }}</span>
												</b-form-group>
											</div>

											<div class="col-6 col-md-3">
												<label class="akkurate-dark" for="approved_by">RO</label>
												<b-form-group id="approved_by" label-for="approved_by">
													<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="getRoInfo" disabled></b-form-input>
												</b-form-group>
											</div> -->
												</div>
												<div class="row" v-if="
													String(
														form.customer_type
													).toUpperCase() == 'GROUP'
												">
													<div class="col-md-12">
														<div class="card card-shape home-box">
															<div class="card-header">
																<h6 class="akkurate-green m-0 fw-bold">
																	Signatories
																</h6>
															</div>
															<div class="card-body">
																<b-table striped bordered responsive id="signatory-table" :busy.sync="isBusy" :items="signatory_rows
																	" :fields="signatory_fields
																		" :tbody-tr-class="rowClass
																			" show-empty>
																	<template #cell(images)="data">
																		<div class="d-flex">
																			<img class="me-2" width="50px" height="50px" :src="base_url +
																				'/' +
																				data
																					.item
																					.profile_photo
																				" />
																			<img class="me-2" width="50px" height="50px" :src="base_url +
																				'/' +
																				data
																					.item
																					.ghana_card_front
																				" />
																			<img class="me-2" width="50px" height="50px" :src="base_url +
																				'/' +
																				data
																					.item
																					.ghana_card_back
																				" />
																			<img class="me-2" width="50px" height="50px" :src="base_url +
																				'/' +
																				data
																					.item
																					.signature
																				" />
																		</div>
																	</template>
																	<!-- <template #cell(ghana_card_front)="data">
                                                  
                                                </template>
                                                <template #cell(ghana_card_back)="data">
                                                   
                                                </template>
                                                <template #cell(signature)="data">
                                                    
                                                </template> -->
																</b-table>
															</div>
														</div>
													</div>

												</div>
											</b-card-body>
										</b-card>
									</b-card-group>
								</div>
							</div>
						</div>

					</b-tab>
					<!-- Employee Details -->
					<b-tab>
						<template #title>
							<font-awesome-icon :icon="['fas', 'briefcase']" /><br><!-- Font Awesome icon -->
							Employee Details
						</template>
						<div class="card card-shape home-box">
							<div class="card-body">
								<div class="col-12 col-md-12">
									<div class="row">
										<div class="col-12 col-md-6">
											<label class="akkurate-small akkurate-dark" for="status">Status
												<star></star>
											</label>
											<b-form-group id="status" label-for="status">
												<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.status" disabled></b-form-input>
											</b-form-group>
										</div>
										<div class="col-12 col-md-6">
											<label class="akkurate-small akkurate-dark" for="employer_name">Name of
												Institution/
												Employer Name
												<star></star>
											</label>
											<b-form-group id="employer_name" label-for="employer_name">
												<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.employer_name" disabled></b-form-input>
											</b-form-group>
										</div>
										<div class="col-12 col-md-6">
											<label class="akkurate-small akkurate-dark" for="staff_id">Staff Number
												<star></star>
											</label>
											<b-form-group id="staff_id" label-for="staff_id">
												<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.staff_id" disabled></b-form-input>
											</b-form-group>
										</div>
										<div class="col-12 col-md-6">
											<label class="akkurate-small akkurate-dark" for="employer_address">Employer's Address
												<star></star>
											</label>
											<b-form-group id="employer_address" label-for="employer_address">
												<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.employer_address" disabled></b-form-input>
											</b-form-group>
										</div>
										<div class="col-12 col-md-6">
											<label class="akkurate-small akkurate-dark" for="position">Position
												<star></star>
											</label>
											<b-form-group id="position" label-for="position">
												<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.position" disabled></b-form-input>
											</b-form-group>
										</div>
										<div class="col-12 col-md-6">
											<label class="akkurate-small akkurate-dark" for="occupation">Occupation
												<star></star>
											</label>
											<b-form-group id="occupation" label-for="occupation">
												<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.occupation" disabled></b-form-input>
											</b-form-group>
										</div>
										<div class="col-12 col-md-6">
											<label class="akkurate-small akkurate-dark" for="place_of_work">Place of
												work
												<star></star>
											</label>
											<b-form-group id="place_of_work" label-for="place_of_work">
												<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.place_of_work" disabled></b-form-input>
											</b-form-group>
										</div>
									</div>
								</div>
							</div>
						</div>

					</b-tab>
					<!-- Financial Information	 -->
					<b-tab>
						<template #title>
							<font-awesome-icon :icon="['fas', 'dollar-sign']" /><br><!-- Font Awesome icon -->
							Financial Info
						</template>
						<div class="card card-shape home-box">
							<div class="card-body">
								<div class="col-12 col-md-12">
									<!-- <div class="card-header d-flex flex-row align-items-center">
                                    <h6 class="m-0 fw-bold text-green">Financial Information</h6>
                                </div> -->
									<financial-information :form="form" :add_or_edit="add_or_edit">
									</financial-information>


								</div>
							</div>
						</div>
					</b-tab>
					<b-tab>
						<template #title>
							<font-awesome-icon :icon="['fa', 'user-friends']" aria-hidden="true" /><br><!-- Font Awesome icon -->
							Spouse Info
						</template>
						<div class="card card-shape home-box">
							<div class="row card-body">
								<div class="col-12 col-md-6">
									<label class="akkurate-small akkurate-dark" for="spouse_name">Spouse Name
									</label>
									<b-form-group id="spouse_name" label-for="spouse_name">
										<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.spouse_name" disabled></b-form-input>
									</b-form-group>
								</div>
								<div class="col-12 col-md-6">
									<label class="akkurate-small akkurate-dark" for="spouse_phone">Spouse Phone
										Number
									</label>
									<b-form-group id="spouse_phone" label-for="spouse_phone">
										<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.spouse_phone" disabled></b-form-input>
									</b-form-group>
								</div>
								<div class="col-12 col-md-6">
									<label class="akkurate-small akkurate-dark" for="spouse_email">Spouse Email
									</label>
									<b-form-group id="spouse_email" label-for="spouse_email">
										<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.spouse_email" disabled></b-form-input>
									</b-form-group>
								</div>
								<div class="col-12 col-md-6">
									<label class="akkurate-small akkurate-dark" for="spouse_address">Spouse Address
									</label>
									<b-form-group id="spouse_address" label-for="spouse_address">
										<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.spouse_address" disabled></b-form-input>
									</b-form-group>
								</div>
							</div>
						</div>
					</b-tab>
					<b-tab>
						<template #title>
							<font-awesome-icon :icon="['fas', 'map-location']" /><br><!-- Font Awesome icon -->
							Address
						</template>
						<div class="card card-shape home-box">
							<div class=" card-body">
								<div class="col-md-12">
									<b-card-group deck>
										<b-card>
											<!-- <template #header>
                                        <div>
                                            <h6 class="m-0 fw-bold text-green">Address</h6>
                                        </div>
                                    </template> -->
											<b-card-body>
												<div class="row">
													<div class="col-12 col-md-4">
														<b-form-group label-for="address" class="mb-2">
															<template #label>
																<label class="akkurate-dark" for="address">Address
																	<star>
																	</star>
																</label>
															</template>
															<b-form-textarea class="mt-2 fields" id="address" :value="form.address" disabled></b-form-textarea>
														</b-form-group>
													</div>
													<!-- <div class="col-12 col-md-4">
												<label class="akkurate-dark" for="digital_address">Digital Address
													<star></star>
												</label>
												<b-form-group id="digital_address" label-for="digital_address">
													<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.digital_address" disabled></b-form-input>
												</b-form-group>
											</div> -->

													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="digital_address">
															Digital Address <star></star>
														</label>
														<b-form-group id="digital_address" label-for="digital_address">
															<div @click="$bvModal.show('map-modal-2')" class="custom-pointer position-relative">
																<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.digital_address" disabled></b-form-input>
																<div class="position-absolute top-0 end-0 begin-0 bottom-0 d-flex align-items-center justify-content-center w-100 h-100 z-index-5">
																</div>
															</div>
														</b-form-group>

														<!-- Map Modal -->
														<MapModal :modal-id="'map-modal-2'" :digitalAddress="form.digital_address || ''" />

													</div>

													<!--  -->

													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="search_term">Region</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="region.name" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="search_term">Home Town</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.home_town" disabled></b-form-input>
														</b-form-group>
													</div>
													<div class="col-12 col-md-4">
														<label class="akkurate-dark" for="search_term">Branch</label>
														<b-form-group id="search_term" label-for="search_term">
															<b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="form.branch?.name" disabled></b-form-input>
														</b-form-group>
													</div>
												</div>
											</b-card-body>
										</b-card>
									</b-card-group>
								</div>
							</div>
						</div>

					</b-tab>
					<b-tab>
						<template #title>
							<font-awesome-icon :icon="['fas', 'key']" /><br><!-- Font Awesome icon -->
							Account
						</template>
						<div class="card card-shape home-box">
							<div class=" card-body">
							<vue-good-table :columns="account_columns" :rows="form.accounts">
								<!-- Add your custom delete button column -->
								<template slot="table-row" slot-scope="props">
									<span class="d-flex" v-if="props.column.field == 'account_balance'">
										<span v-if="props.row.account_type?.base_type == 'Loan'">
											{{ displayNumber(Number(Number(props.row.loan?.interest_balance) +
												Number(props.row.loan?.principal_balance)).toFixed(2)) }}
										</span>
										<span v-else>
											{{ displayNumber(Number(props.row?.account_balance).toFixed(2)) }}
										</span>
									</span>

									<span class="d-flex" v-else-if="
										props.column.field ==
										'account_type.name'
									">
										<span v-if="
											props.row?.account_type
												?.base_type == 'Loan'
										">
											{{
												props.row?.loan?.loan_product
													?.name
											}}
										</span>
										<span v-else>
											{{
												props.row?.account_type?.name
											}}
										</span>
									</span>

									<span class="d-flex" v-else-if="
										props.column.field ==
										'account_number'
									">
										<span v-if="
											props.row.account_type
												.base_type == 'Loan'
										">
											{{ props.row.loan?.loan_number }}
										</span>
										<span v-else>
											{{ props.row?.account_number }}
										</span>
									</span>

									<span class="d-flex" v-else-if="props.column.field == 'action'
									">
										<a :title="props.row?.account_type.base_type + ' Statement'" 
										v-if="
												(props.row.account_type?.base_type ==
												'Savings' || props.row.account_type?.base_type =='Shares' ) &&
												view_statement
											" class="btn btn-sm akkurate-gray-btn text-white" v-b-modal="String(
												props.row?.id +
												'account_statement'
											)
												">
											<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'book']" /></span>
										</a>
										<account-statement :data="props.row" :institution="institution
											"></account-statement>
										<a :title="props.row?.account_type.base_type +
											' Statement'
											" v-if="
												props.row?.account_type
													?.base_type == 'Loan' &&
												view_loan_statement
											" class="btn btn-sm akkurate-gray-btn text-white" v-b-modal="String(
												props.row?.id +
												'statement'
											)
												">
											<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'book']" /></span>
										</a>
										<loan-statement :data="props.row" :statement="'statement'" :institution="institution" :branch="props.row?.account?.customer
											?.branch
											"></loan-statement>
									</span>

									<span v-else>
										{{
											props.formattedRow[
											props.column.field
											]
										}}
									</span>
								</template>
							</vue-good-table>
						</div>
			</div>
			</b-tab>
			<b-tab :active="active_beneficiary">
				<template #title>
					<font-awesome-icon :icon="['fas', 'users']" /><br><!-- Font Awesome icon -->
					Beneficiaries
				</template>
				<div class="card card-shape home-box">
					<div class=" card-header pe-1">
					<div class="d-flex justify-content-between align-items-center">
						<div>
							<h6 class="m-0 font-md font-bold font-primary">Beneficiary</h6>
						</div>
						<div>
							<b-button class="btn btn-sm btn-size akkurate-green-btn font-md font-bold text-nowrap" @click="showBeneficiaryAddModal()" variant="primary">
								<span><i class="fas fa-plus"></i> Add Beneficiary</span>
							</b-button>
						</div>
					</div>
				</div>
				<div class="card-body table_text_size">
					<b-table striped bordered responsive id="beneficiary-table" :busy.sync="isBusy" :items="form.beneficiaries" :fields="beneficiary_fields" :tbody-tr-class="rowClass" show-empty class="table-row-hover">
						<template #cell(actions)="data">
							<a title="Edit" class="btn btn-sm akkurate-blue text-white broder-0 custom-pointer font-sm font-bold" @click="showBeneficiaryEditModal(data.item)">
								<span><font-awesome-icon :icon="['fas', 'edit']" /></span>
							</a>
							<a title="Delete" class="btn btn-sm akkurate-danger-btn text-white font-sm font-bold" @click="confirmDeleteBeneficiary(data.item)">
								<span><font-awesome-icon :icon="['fas', 'trash']" /></span>
							</a>
						</template>
						<template #empty>
							<div class="text-center font-md font-muted py-4">No beneficiaries found. Click
								"Add Beneficiary" to create one.</div>
						</template>
					</b-table>
				</div>
		</div>
		</b-tab>
		<b-tab>
			<template #title>
				<font-awesome-icon :icon="['fas', 'history']" /><br><!-- Font Awesome icon -->
				History
			</template>
			<div class="card card-shape home-box">
					<div class=" card-body table_text_size">
				<!-- <vue-good-table styleClass="vgt-table bordered table-dropdown striped" mode="remote"
									ref="attachTable" :columns="history_fields" :items="history_data">
								</vue-good-table> -->
				<b-table striped bordered responsive id="history-table" :busy.sync="isBusy" :items="history_data" :fields="history_fields" :tbody-tr-class="rowClass" show-empty class="table-row-hover">
					<template #cell(created_at)="data">
						{{ formatDateAndTime(data.item.created_at) }}
					</template>

					<template #cell(approved_at)="data">
						{{ formatDateAndTime(data.item.approved_at) }}
					</template>
				</b-table>
			</div>
	</div>
	</b-tab>
	</b-tabs>
	<b-modal @ok="handleAddBenefit" id="bv-modal-benficiaries-add" title="Beneficiary" ref="modal" size="lg">
		<template #modal-title>
			<h6 class="text-center fw-bold akkurate-green mb-0">
				Add Beneficiary
			</h6>
		</template>
		<form @submit.stop.prevent="submitAddBeneficiary">
			<beneficiary-form :form="beneficiary_form"></beneficiary-form>
		</form>

		<template #modal-footer="{ ok, cancel }">
			<b-button v-b-modal.ok @click="ok()" class="btn akkurate-green-btn btn-size text-white">Save</b-button>
			<b-button v-b-modal.cancel @click="cancel()" class="btn akkurate-gray-btn btn-size text-white">Close</b-button>
		</template>
	</b-modal>

	<b-modal @ok="handleEditBenefit" id="bv-modal-benficiaries-edit" ref="modal" size="lg">
		<template #modal-title>
			<h6 class="text-center fw-bold akkurate-green mb-0">
				Edit Beneficiary
			</h6>
		</template>
		<form @submit.stop.prevent="submitEditBeneficiary">
			<beneficiary-form :form="beneficiary_form"></beneficiary-form>
		</form>
		<template #modal-footer="{ ok, cancel }">
			<b-button @click="ok()" v-b-modal.ok type="submit" class="btn akkurate-green-btn btn-size text-white">Update</b-button>
			<b-button @click="cancel()" v-b-modal.cancel class="btn akkurate-gray-btn btn-size text-white">Close</b-button>
		</template>
	</b-modal>
	</div>
	</div>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import ApiService from "@/core/services/api.service";
// import EditNextOfKin from '../edit/modal/EditNextOfKin.vue'
import AccountStatement from "../accounts/statement/AccountStatement.vue";
import LoanStatement from "../../loan/statements/LoanStatement.vue";
import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";
import EmployerDetails from "../forms/EmployerDetails.vue";
import FinancialInformation from "../forms/FinancialInformation";
// import AddNextOfKin from '../edit/modal/AddNextOfKin.vue';
import BeneficiaryForm from "../edit/modal/BeneficiaryForm.vue";
import { hasPermission } from "@/helper";
import baseUrlConfig from "@/config";
import L from 'leaflet';
import MapModal from "@/views/components/MapModal.vue";

export default {
	components: {
		SidebarView,
		TopbarView,
		// AddNextOfKin,
		// EditNextOfKin,
		BeatLoaderComponent,
		AccountStatement,
		LoanStatement,
		EmployerDetails,
		FinancialInformation,
		MapModal,
		BeneficiaryForm,
	},
	created() {
		this.getMemberView();
		this.checkPemission();
	},
	props: {
		id: {
			required: true
		},
		institution: {
			required: true
		}
	},
	data() {
		return {
			base_url: baseUrlConfig.base_url,
			add_or_edit: 'view',
			active_beneficiary: false,
			form: {
				id: 0,
				code: 0,
				first_name: "",
				middlename: "",
				last_name: "",
				title: "",
				email: "",
				mobile: "",
				gender: "",
				date_of_birth: "",
				marital_status: "",
				address: "",
				digital_addres: "",
				home_town: "",
				landmark: "",
				employer_name: "",
				ghana_card_number: "",
				status: "",
				branch: {},

				employer_address: null,
				employer_mobile: null,
				occupation: null,
				employee_position: null,
				source_of_funds: null,
				bankers_name: null,
				bankers_address: null,
				bankers_location: null,
				monthly_salary: null,
				signature_image_path: null,
				signature_image_name: null,
				passport_pic_path: null,
				passport_pic_name: null,
				note: null,
				mandate: null,
				errors: [],
				employment_status: "",
			},
			branch: [],
			region: [],
			imageLoaded: false,
			isLoading: false,
			isBusy: false,
			beneficiary_form: {
				id: 0,
				surname: "",
				first_name: "",
				email: "",
				phone_number: "",
				relation: "",
				address: "",
				model_id: "",
				errors: [],
			},

			//Accounts
			account_columns: [
				// {
				//     label: 'Account ID',
				//     field: 'id',
				// },
				{
					label: "Account Type Name",
					field: "account_type.name",
				},
				{
					label: "Account No. /Loan No.",
					field: "account_number",
				},
				{
					label: "Balance",
					field: "account_balance",
				},
				{
					label: "Status",
					field: "status",
					type: "string",
				},
				{
					label: "Action",
					field: "action",
					type: "string",
				},
			],
			account_rows: [],
			view_statement: false,
			view_loan_statement: false,
			signatory_rows: [],
			signatory_fields: [
				{
					label: "Name",
					key: "name",
				},
				{
					label: "Position",
					key: "position",
				},
				{
					label: "ID Type",
					key: "id_type.value",
				},
				{
					label: "ID Number",
					key: "id_number",
				},
				{
					label: "Images",
					key: "images",
				},
				// {
				//     label: "Ghana Card Front",
				//     key: "ghana_card_front"
				// },
				// {
				//     label: "Ghana Card Back",
				//     key: "ghana_card_back"
				// },
				// {
				//     label: "Signature",
				//     key: "signature"
				// },
			],

			//Beneficiaries
			beneficiary_fields: [
				{
					label: "#",
					key: "id",
				},
				{
					label: "Surname",
					key: "surname",
				},
				{
					label: "Other names",
					key: "first_name",
				},
				{
					label: "Email",
					key: "email",
				},
				{
					label: "Phone number",
					key: "phone_number",
				},
				{
					label: "Relation",
					key: "relation",
				},
				{
					label: "Address",
					key: "address",
				},
				{
					label: "Percentage(%)",
					key: "percentage_share",
				},
				{
					label: "Actions",
					key: "actions",
				},
			],
			history_fields: [
				{
					label: "Created At",
					key: "created_at",
				},
				{
					label: "Created by",
					key: "created_by",
				},
				{
					label: "Approved At",
					key: "approved_at",
				},
				{
					label: "Approved by",
					key: "approved_by",
				},
				{
					label: "Event Details",
					key: "event",
				},
			],
			history_data: [],
			next_rows: [],
		};
	},
	computed: {
		getRoInfo() {
			if (this.form?.ro?.first_name) {
				return this.form?.ro?.first_name + " " + this.form?.ro?.surname + " - " + this.form?.ro?.id;
			}
			else if (this.form?.ro?.name) {
				return this.form?.ro?.name + " - " + this.form?.ro?.id;
			}
			else {
				return this.form?.ro || "";
			}
		},
		getFullName() {
			const first_name = this.form.first_name != undefined ? this.form.first_name : "";
			const middle_name = this.form?.middle_name != undefined ? this.form.middle_name : "";
			const last_name = this.form.last_name != undefined ? this.form.last_name : "";
			return first_name + " " + middle_name + " " + last_name;
		},
		getBranch() {
			const branch = this.form.branch?.name ? this.form.branch?.name : "";
			return branch;
		}
	},
	methods: {
		setUserStatus(status, data) {
			swal.fire({
				title: "Are you sure?",
				html:
					`You want to set member status to <strong>${status}</strong> for <strong>${data.first_name}` +
					` ${data.last_name}</strong>?`,
				icon: "warning",
				allowOutsideClick: true,
				allowEscapeKey: true,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Yes", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.$Progress.start();
					await ApiService.put(
						`/customers/status-update/${data.id}`,
						{
							status: status,
						}
					)
						.then((response) => {
							// console.log(response);
							this.$Progress.finish();
							swal.fire({
								title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.getMemberView();
						})
						.catch((error) => {
							this.$Progress.fail();
							console.log(error);
						});
					//
				}
			});
		},
		statusBadge(item) {
			// if (item.get_pending_request_member_edit.length > 0) {
			// 	
			// }
			const stat = item.toLowerCase()
			if (item.length == 0) {
				return 'badge akkurate-custom-mid-green'
			}
			if (stat === 'active') {
				return 'badge akkurate-green-bg'
			} else if (stat === 'inactive') {
				return 'badge akkurate-danger-bg'
			} else if (stat === 'dormant') {
				return 'badge akkurate-danger-bg'
			} else if (stat === 'pending') {
				return 'badge akkurate-warning-bg'
			} else {
				return 'badge akkurate-warning-bg'
			}
		},
		activeStatusBadge(item) {
			const stat = item.toLowerCase()
			if (item.length == 0) {
				return 'badge akkurate-custom-mid-green'
			}
			if (stat === 'active') {
				return 'badge akkurate-green-bg'
			} else if (stat === 'inactive') {
				return 'badge akkurate-danger-bg'
			} else if (stat === 'dormant') {
				return 'badge akkurate-danger-bg'
			} else if (stat === 'pending') {
				return 'badge akkurate-warning-bg'
			} else {
				return 'badge akkurate-warning-bg'
			}
		},
		customerTypeTitle() {
			if (
				String(this.form.customer_type).toUpperCase() ==
				"INDIVIDUAL"
			) {
				return "Personal Details";
			} else if (
				String(this.form.customer_type).toUpperCase() == "GROUP"
			) {
				return "Group Details";
			} else if (
				String(this.form.customer_type).toUpperCase() == "CORPORATE"
			) {
				return "Corporate Details";
			} else {
				return "Personal Details";
			}
		},
		profileLabel() {
			if (
				String(this.form.customer_type).toUpperCase() ==
				"INDIVIDUAL"
			) {
				return "Profile Picture";
			} else if (
				String(this.form.customer_type).toUpperCase() == "GROUP"
			) {
				return "Group Logo";
			} else if (
				String(this.form.customer_type).toUpperCase() == "CORPORATE"
			) {
				return "Corporate Logo";
			} else {
				return "profile picture";
			}
		},
		checkPemission() {
			// console.log(hasPermission('transaction_management_statement'))
			this.view_statement = hasPermission(
				"transaction_management_statement"
			);
			this.view_loan_statement = hasPermission(
				"loan_management_statement"
			);
		},

		showBeneficiaryEditModal(data) {
			// console.log(data);
			this.initialBenefitForm();
			this.beneficiary_form = data;
			this.$bvModal.show("bv-modal-benficiaries-edit");
		},
		showBeneficiaryAddModal() {
			this.initialBenefitForm();
			this.$bvModal.show("bv-modal-benficiaries-add");
		},
		async getMemberView() {
			this.isLoading = true;
			await ApiService.get("/customers/view/" + this.id)
				.then((response) => {
					// console.log(response.data.data);
					this.form = response.data.data;
					console.log(this.form);
					this.region =
						response.data.data.region != null
							? response.data.data.branch
							: "";
					this.branch =
						response.data.data.branch != null
							? response.data.data.branch
							: "";
					this.signatory_rows = response.data.data.signatories;
					this.handleImageLoad();
					this.isLoading = false;
					// console.log(this.form);
					// this.forms = response.data.data;
					// this.per_page = response.data.meta.per_page;
					// console.log(response.data.meta.per_page)
					// this.totalRecords = response.data.meta.total;
				})
				.catch((error) => {
					this.isLoading = false;
					swal.fire({
						// title: response.statusText,
						text: error.response.data.message,
						icon: "error",
						allowOutsideClick: true,
						allowEscapeKey: true,
						showCancelButton: false, // Show the "Cancel" button
						confirmButtonText: "okay", // Customize the text for the "OK" button
						buttonsStyling: false, // Disable SweetAlert2 styling for buttons
						customClass: {
							confirmButton:
								"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
						},
					});
				})
				.finally(() => {
					this.isLoading = false;
					// this.isLoading = false
				});

			this.getMemberUpdateHistory();
		},

		async getMemberUpdateHistory() {
			await ApiService.get("/customers/update/history/" + this.id)
				.then((response) => {
					console.log("History Response: ", response);	
					this.history_data = response.data.data;
					console.log("Update History: ", this.history_data);

				})
				.catch((error) => {
					console.log(error.message);
				})
				.finally(() => {
					this.isLoading = false;
					// this.isLoading = false
				});
		},
		nextofkin() {
			this.getMemberView();
		},

		handleImageLoad() {
			// console.log(this.form?.gh_card_front_path);
			if (this.form?.gh_card_front_path) {
				this.imageLoaded = true;
				this.frontImgUrl = this.form?.gh_card_front_path;
			}
			if (this.form?.gh_card_back_path) {
				this.imageLoaded = true;
				this.backImgUrl = this.form?.gh_card_back_path;
			}

			// console.log("front ", this.frontImgUrl)
			// console.log("Back ", this.backImgUrl)
		},
		rowClass() {
			return "custom-row-height";
		},
		handleAddBenefit(bvModalEvent) {
			// Prevent modal from closing
			bvModalEvent.preventDefault();
			this.submitAddBeneficiary();
		},
		handleEditBenefit(bvModalEvent) {
			// Prevent modal from closing
			bvModalEvent.preventDefault();
			this.submitEditBeneficiary();
		},
		async submitAddBeneficiary() {
			this.isSaving = true;
			this.$Progress.start();
			this.beneficiary_form.errors = [];
			this.beneficiary_form.model_id = this.form.id;
			this.beneficiary_form;
			await ApiService.post(
				"/customers/beneficiaries/store/",
				this.beneficiary_form
			)
				.then((response) => {
					this.isSaving = false;
					this.$Progress.finish();

					toast.fire({
						icon: "success",
						title: response.data.message,
					});
					this.getMemberView();
					this.$nextTick(() => {
						this.$bvModal.hide("bv-modal-benficiaries-add");
					});
					this.active_beneficiary = true;
					this.initialBenefitForm();

					// this.$emit("next_of_kin_edited", response.data.data);

					// // Hide Modal Manually
					// this.$nextTick(() => {
					//     this.$bvModal.hide('edit-nextofkin')
					// })

					// window.location.reload()
					//   this.isSaving = false;
					//   this.form.phone_number = "";
					//   this.form.email = "";
					//   this.form.selected_payment_method = "";
				})
				.catch((error) => {
					this.isSaving = false;
					this.$Progress.fail();
					this.beneficiary_form.errors = [];
					if (error.response.data.errors) {
						// console.log(error.response.data.errors)
						this.beneficiary_form.errors =
							error.response.data.errors;
					}
					// console.log(error.response.data)
				});
		},
		async submitEditBeneficiary() {
			this.isSaving = true;
			this.$Progress.start();
			this.beneficiary_form.errors = [];
			this.beneficiary_form;
			await ApiService.post(
				"/customers/beneficiaries/update/" +
				this.beneficiary_form.id,
				this.beneficiary_form
			)
				.then((response) => {
					this.isSaving = false;
					this.$Progress.finish();
					// console.log(response);

					toast.fire({
						icon: "success",
						title: response.data.message,
					});

					// // Hide Modal Manually
					this.$nextTick(() => {
						this.$bvModal.hide("bv-modal-benficiaries-edit");
					});
					this.getMemberView();
					this.active_beneficiary = true;
					this.initialBenefitForm();

					// window.location.reload()
					//   this.isSaving = false;
					//   this.form.phone_number = "";
					//   this.form.email = "";
					//   this.form.selected_payment_method = "";
				})
				.catch((error) => {
					this.isSaving = false;
					this.$Progress.fail();
					this.form.errors = [];
					if (error.response.data.errors) {
						// console.log(error.response.data.errors)
						this.form.errors = error.response.data.errors;
					}
					// console.log(error.response.data)
				});
		},
		async confirmDeleteBeneficiary(data) {
			swal.fire({
				title: "Delete Beneficiary",
				text:
					"Are you sure you want to delete " +
					data?.first_name +
					" ?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				allowOutsideClick: true,
				customClass: {
					cancelButton:
						"btn btn-size akkurate-green-gray modal-btn-width text-white me-2", // Custom class for the "NO" button
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "YES" button
				},
			}).then(async (result) => {
				if (result.value) {
					this.$Progress.start();
					await ApiService.delete(
						"/beneficiaries/delete/" + data.id
					)
						.then((response) => {
							this.$Progress.finish();
							this.beneficiary_form;
							this.initialBenefitForm();
							swal.fire({
								// title: response.statusText,
								text: response?.data?.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.getMemberView();
							this.active_beneficiary = true;
						})
						.catch((error) => {
							this.$Progress.fail();
							swal.fire({
								// title: response.statusText,
								text: error?.response?.data?.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
						});
				}
			});
		},
		initialBenefitForm() {
			this.beneficiary_form = {
				id: 0,
				surname: "",
				first_name: "",
				email: "",
				phone_number: "",
				relation: "",
				address: "",
				model_id: "",
				errors: [],
			};
		},
	},
};
</script>
